<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑成员':'新增成员'" :visible.sync="dialog" @close="unShowClick()" width="40%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="成员名称" prop="name" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<el-input v-model="addBody.name" placeholder="请输入成员名称"></el-input>
				</el-form-item>
				<el-form-item label="成员身份" prop="identity" :label-width="formLabelWidth">
					<el-select v-model="addBody.identity" placeholder="请选择成员身份">
						<el-option v-for="item in lmList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
					<el-input v-model="addBody.phone" placeholder="请输入手机号"></el-input>
				</el-form-item> -->
				<el-form-item label="账号" prop="account" :label-width="formLabelWidth">
					<el-input :disabled="isEdit ? true : false" v-model="addBody.account" placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password" :label-width="formLabelWidth">
					<el-input v-model="addBody.password" placeholder="请输入密码"></el-input>
					*密码8位数以上，包含数字、大小写字母、特殊符号任意两种组合
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addUser,
		editUser,
		getUser
	} from '@/api/user-manage'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					identity: '',
					name: '',
					phone: "",
					account: "",
					password: '',
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					identity: [{
						required: true,
						message: '请选择身份',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					// phone: [{
					// 	required: true,
					// 	message: '请输入手机号',
					// 	trigger: 'blur'
					// }, ],
					account: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				]
			}
		},
		mounted() {},
		methods: {
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				if(!this.validatePassword(this.addBody.password)){
					return this.$message.error('密码8位数以上，包含数字、大小写字母、特殊符号任意两种组合')
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addUser()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addUser: async () => {
						const {
							status,
							data
						} = await addUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editUser: async () => {
						const {
							status
						} = await editUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {

					this.isEdit = true;
					this.network().getUser(val.uuid)
				} else {
					this.isEdit = false;
					this.addBody.identity = ''
					this.addBody.name = ''
					this.addBody.phone = ''
					this.addBody.account = ''
					this.addBody.password = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>